import type { FaireProductEntity } from "../../entity_types/product";

export const atc_goes_well_2: FaireProductEntity = {
  token: "atc_goes_well_2",
  type: "product",
  name: "Washi Tape Set of 5",
  brandName: "The Completist",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/aff1dd6ff0c99171ef36627c3ac365a59271d96dd6249212618c9c2dab06cc3d.jpeg",
  priceDollars: 12,
  msrpDollars: 24,
  description: "Recommended accessory for ATC flow.",
  tags: ["goes-well-with", "atc"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
